/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/breadcrumb/custom-elements';

import { defineCustomElement as defineOsdsBreadcrumb } from '@ovhcloud/ods-stencil/components/breadcrumb/custom-elements/osds-breadcrumb.js';
import { defineCustomElement as defineOsdsBreadcrumbItem } from '@ovhcloud/ods-stencil/components/breadcrumb/custom-elements/osds-breadcrumb-item.js';

export const OsdsBreadcrumb = /*@__PURE__*/createReactComponent<JSX.OsdsBreadcrumb, HTMLOsdsBreadcrumbElement>('osds-breadcrumb', undefined, undefined, defineOsdsBreadcrumb);
export const OsdsBreadcrumbItem = /*@__PURE__*/createReactComponent<JSX.OsdsBreadcrumbItem, HTMLOsdsBreadcrumbItemElement>('osds-breadcrumb-item', undefined, undefined, defineOsdsBreadcrumbItem);
